import { html } from "../../../../../../../_ovlclient/src"
import type { SYSAction } from "../../../../../../../_ovlclient/src"
import { N0, T } from "../../../../../../../_ovlclient/src/global/globals"
import type {
  HookFieldGetEditHint_ReturnType,
  HookFieldGetEditHint_Type,
  HookFieldGetList_ReturnType,
  HookFieldGetList_Type,
  HookFieldGetValueRender_ReturnType,
  HookFieldGetValueRender_Type,
  HookFormChanged_Type,
  HookFormValidate_Type,
  HookViewRowClass_Type,
} from "../../../../../../../_ovlclient/src/global/hooks"
import {
  FieldVal,
  FieldSetForceChange,
  FieldIsFocused,
  FieldIsValid,
} from "../../../../../../../_ovlclient/src/library/forms/fieldapi"
import type { ViewRowClassType } from "../../../../../../../_ovlclient/src/library/table/table"
import { TableGet } from "../../../../../../../_ovlclient/src/library/table/tableapi"

const HookViewRowClass: SYSAction<HookViewRowClass_Type, ViewRowClassType> = (
  value,
  { global }
) => {
  let state = global.getState()
  let res: ViewRowClassType
  let partId = value.tableData.data[value.rowKey]["U_PartId"]
  if (partId === state.app.features.DATSearchPaket.selectedPaket) {
    res = {
      className: "searchpaket_rowtoselect searchpaket_id_" + partId,
      tooltip: "",
    }
  } else {
    res = {
      className: "searchpaket_id_" + partId,
      tooltip: "",
    }
  }
  return res
}

// const HookFormValidate: SYSAction<HookFormValidate_Type> = (
//   value,
//  { global }
// ) => {
//let state = global.getState()
//   if (value.field.fieldKey === "Search") {
//     state.app.features.DATSearchPaket.selectedPaket = undefined
//     FieldSetForceChange(value.field)
//   }
// }

const HookFormChanged: SYSAction<HookFormChanged_Type> = (
  value,
  { global }
) => {
  let state = global.getState()
  let changedField = value.changedField
  if (
    changedField &&
    changedField.field.fieldKey === "Search" &&
    changedField.validValueChanged
  ) {
    state.app.features.DATSearchPaket.selectedPaket = FieldVal(
      value.changedField.field
    )

    let elToScrollTo = document.querySelector(
      `.searchpaket_id_${changedField.newValue}`
    )
    if (elToScrollTo) {
      elToScrollTo.scrollIntoView({
        behavior: "auto",
        block: "center",
      })
    } else {
      window.scrollTo(0, 0)
    }
  }
}

const HookField_MobileDesc_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type,
  HookFieldGetValueRender_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let row = value.row
  // prettier-ignore
  let res = html`<span class="paketsearch_mobiledesc_id">${row["U_PartId"]}</span>: ${row["U_ReqQuantity"]} * ${row["U_SK"]} ${N0(row["U_Width"] as number)} * ${N0(row["U_Height"] as number)} * ${N0(row["U_Length"] as number)} / ${row["U_Profile"]}`
  return { res, useDefault: false }
}

const HookField_Search_GetEditHint: SYSAction<
  HookFieldGetEditHint_Type,
  HookFieldGetEditHint_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  if (!FieldIsValid(value.field) || FieldIsFocused(value.field)) {
    return null
  }
  let partId = value.row["Search"]
  if (partId) {
    let def = TableGet("DATSearchPaket", {
      byCustomFilter: (k) => k["U_PartId"] === partId,
    })
    let foundKey = def.getKeys()
    if (foundKey.length > 0) {
      return T("SPKSearchPaketSearchPaketFoundHint", [
        def.dataDef.data[foundKey[0]]["U_Unit"],
      ])
    } else {
      return null
    }
  } else {
    return null
  }
}

const HookField_Search_GetList: SYSAction<
  HookFieldGetList_Type,
  HookFieldGetList_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let res: HookFieldGetList_ReturnType
  let searchpaket = state.app.global.DAT.tables.DATSearchPaket
  let data =
    searchpaket.tableDef.DATSearchPaket.uiState.dataFilteredAndSorted.reduce(
      (val, i) => {
        let partId = searchpaket.data[i]["U_PartId"]
        val[partId] = {
          U_PartId: partId,
          U_Unit: searchpaket.data[i]["U_Unit"],
        }
        return val
      },
      {}
    )
  res = {
    data,
    lookupDef: {
      U_PartId: {
        type: "text",
        translationKey: "SPKSearchPaketSearchPaketLookupPartId",
      },
      U_Unit: {
        type: "text",
        translationKey: "SPKSearchPaketSearchPaketLookupUnit",
      },
    },
  }
  return res
}

export let hooks = {
  HookViewRowClass,
  /*HookFormValidate,*/
  HookFormChanged,
  HookField_MobileDesc_GetValueRender,
  HookField_Search_GetEditHint,
  HookField_Search_GetList,
}
